"use strict";

exports.__esModule = true;
exports.convertEmptyStringToNull = void 0;

/**
* Converts strings with length 0 to null, else just adds the properties.
* @todo adjust for nested properties
* @param {*} message
* @returns
*/
const convertEmptyStringToNull = message => {
  let preparedObject = {};

  for (let key of Object.keys(message)) {
    preparedObject[key] = typeof message[key] === 'string' ? message[key].length > 0 ? message[key] : null : message[key];
  }

  return preparedObject;
};

exports.convertEmptyStringToNull = convertEmptyStringToNull;